import TermsOfUseContent from './TermsOfUseContent';

export default TermsOfUseContent;
